import { ERROR_NOT_INITIALIZED } from './messages';

export const getContext = () => window?.__htmlEvents__?.eventsPath;
export const getVisit = () => window?.__htmlEvents__?.visit;

export const checkInitialized = () => {
  const visit = getVisit();
  if (visit && getContext()) {
    return Promise.resolve(visit);
  } else {
    return Promise.reject(new Error(ERROR_NOT_INITIALIZED));
  }
};

export const init = ({ context, visitID }) => {
  window.__htmlEvents__ = {
    visit: visitID,
    eventsPath: context,
  };
};
